import VideoPlayer from './VideoPlayer.js';
new VideoPlayer();
